import React from 'react'
import cn from 'classnames'
import styles from './NewPastImages.module.scss'
import PastImage from './PastImage'

export default function TwoRowImageMarkup({ studentImages, backgroundUrl, selectedImages, toggleImage }) {
  return (
    <div className={cn(styles.imageContainer, styles[`imageContainer${studentImages.length}`])}>
      <div className={styles.row}>
        {studentImages.slice(0, Math.floor(studentImages.length / 2)).map((studentImage) => (
          <PastImage
            studentImage={studentImage}
            backgroundUrl={backgroundUrl}
            selectedImages={selectedImages}
            toggleImage={toggleImage}
          />
        ))}
      </div>
      <div className={styles.row}>
        {studentImages.slice(Math.floor(studentImages.length / 2), studentImages.length + 1).map((studentImage) => (
          <PastImage
            studentImage={studentImage}
            backgroundUrl={backgroundUrl}
            selectedImages={selectedImages}
            toggleImage={toggleImage}
          />
        ))}
      </div>
    </div>
  )
}
